import React from 'react';
import { Spinner, Container} from "reactstrap";


const LoadingContainer = (props) => {
    return <Container><Spinner className="mr-2" color="primary"/></Container>
};

export default LoadingContainer;